import { openSubscribe } from "./SubscribeModalHost";
import { useIsSubscribed } from "../lib/useIsSubscribed";
import { useT } from "../lib/LangContext";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { DigestLaunchNotice } from "./DigestLaunchNotice";

// Placement 1 (Hero CTA Strip) — full-width dark bar with a left green
// accent, headline stack, and right-side Join Free button. Placement 5
// (In-Feed Card) uses the same design with border-radius 12px, so this
// component accepts a `rounded` prop.
export const HeroCTAStrip = ({ source = "hero_strip", rounded = false, testid = "hero-cta-strip" }) => {
  const isSubscribed = useIsSubscribed();
  const { t } = useT();
  if (isSubscribed) return null;
  return (
    <div
      className={`relative bg-[#1A2E35] text-white overflow-hidden ${
        rounded ? "rounded-xl" : ""
      } flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 sm:p-5 pl-6 sm:pl-6`}
      data-testid={testid}
    >
      <span
        className="absolute left-0 top-0 bottom-0 w-1 bg-[#25D366]"
        aria-hidden="true"
      />
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <WhatsAppIcon
          size={24}
          className="text-[#25D366] shrink-0 mt-0.5"
        />
        <div className="min-w-0">
          <div className="text-white text-[16px] font-bold leading-snug">
            {t("digest_cta_headline")}
          </div>
          <div className="text-white/70 text-[12px] leading-snug mt-1">
            {t("digest_cta_sub")}
          </div>
          <DigestLaunchNotice
            tone="dark"
            className="mt-2"
            testid={`${testid}-launch-notice`}
          />
          <div className="text-white/70 text-[12px] leading-snug mt-2">
            {t("consent")}
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={() => openSubscribe(source)}
        className="bg-[#25D366] hover:bg-[#1fb954] text-white font-bold px-6 py-3 rounded-lg text-sm shrink-0 w-full sm:w-auto transition-colors"
        data-testid={`${testid}-btn`}
      >
        {t("digest_cta_button")}
      </button>
    </div>
  );
};
